// extracted by mini-css-extract-plugin
export default {"bottomShadow":"SettingsModal_bottomShadow__oS9GU","mainActionButton":"SettingsModal_mainActionButton__OXG72"};